$(function(){
    if( $("body").is("#hanasaijiki") ){
        $(".sec-calendar .data-name tr").each(function(i){
            $(this).attr("data-num", i);
        });

        $(".sec-calendar .data-flower tr").each(function(i){
            $(this).attr("data-num", i);
            $("[data-num='"+ i +"']").tile();
        });
    }
});


// WEBPACK FOOTER //
// ./_src/js/cont/hana.js